// import React, { useState, useEffect } from 'react';

function Hero() {



  return (
          null  
  )
}

export default Hero;
